export const NO_DISTANCE_MINUTES = 'No walking time estimation';
export const NO_ADDRESS = 'No address added';
export const NO_WEBPAGE = 'No website added';
